import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Reveal } from "./Reveal";

const APP_STORE_URL = "https://apps.apple.com/us/app/groomiq/id6787042178";

export default function GroomIQTeaser() {
  return (
    <section data-testid="groomiq-teaser" className="bg-white py-8 lg:py-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative flex flex-col items-center gap-5 overflow-hidden rounded-xl bg-gradient-to-br from-lavender-600 via-lavender-700 to-lavender-800 p-6 text-white shadow-[0_18px_40px_-14px_rgba(109,40,217,0.6)] ring-1 ring-inset ring-white/15 sm:flex-row sm:gap-7 sm:p-8">
            <div className="pointer-events-none absolute -right-20 -top-24 h-56 w-56 rounded-full bg-white/10 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 left-1/3 h-48 w-48 rounded-full bg-lavender-400/20 blur-3xl" />
            <span data-testid="groomiq-teaser-new" className="pointer-events-none absolute right-4 top-4 z-10 animate-newflash rounded-md bg-gradient-to-br from-rose-500 to-red-600 px-2 py-1 text-[10px] font-extrabold uppercase leading-none tracking-wider text-white shadow-[0_2px_8px_rgba(244,63,94,0.6)] ring-1 ring-white/50">New</span>
            <div className="relative shrink-0 rounded-2xl bg-white/95 p-2 shadow-lg ring-1 ring-white/40">
              <img
                src="/assets/groomiq-logo.jpg"
                alt="GroomIQ"
                data-testid="groomiq-teaser-logo"
                className="h-16 w-16 rounded-xl object-cover sm:h-[76px] sm:w-[76px]"
              />
            </div>
            <div className="relative flex-1 text-center sm:text-left">
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-lavender-200">Now on the App Store</p>
              <p className="mt-2 font-serif text-2xl leading-snug sm:text-3xl">Meet GroomIQ, pup analysis that shows you how to keep up at home until your pup's next spa day.</p>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-lavender-100">
                Snap one photo and get simple coat tips, brushing reminders and heads-ups so your dog stays comfy between visits.
              </p>
            </div>
            <div className="relative z-10 flex w-full shrink-0 flex-col gap-2.5 sm:w-auto lg:hidden" data-testid="groomiq-teaser-buttons">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="groomiq-teaser-appstore"
                className="inline-flex items-center justify-center rounded-lg bg-white px-7 py-3.5 text-sm font-bold text-lavender-800 shadow-[0_10px_26px_-8px_rgba(0,0,0,0.3)] ring-1 ring-inset ring-white/60 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-lavender-50 hover:shadow-[0_16px_34px_-8px_rgba(0,0,0,0.4)]"
              >
                Download on the App Store
              </a>
              <Link
                to="/groomiq"
                data-testid="groomiq-teaser-cta"
                className="inline-flex items-center justify-center rounded-lg border border-white/50 px-7 py-3 text-sm font-bold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-white/10"
              >
                Learn more
              </Link>
            </div>
            <div className="relative z-10 hidden shrink-0 flex-col items-center gap-2 lg:mr-10 lg:flex" data-testid="groomiq-teaser-qr">
              <div className="rounded-xl bg-white p-2.5 shadow-[0_10px_26px_-8px_rgba(0,0,0,0.35)] ring-1 ring-inset ring-white/60">
                <QRCodeSVG value={APP_STORE_URL} size={104} bgColor="#ffffff" fgColor="#4c1d95" level="M" />
              </div>
              <p className="text-center text-xs font-semibold leading-snug text-lavender-100">
                Scan with your phone to download
              </p>
              <Link to="/groomiq" data-testid="groomiq-teaser-qr-learn" className="text-xs font-semibold text-white underline decoration-white/50 underline-offset-4 transition-colors hover:decoration-white">
                Learn more
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
